import React from 'react'
import Resx from '@/components/Resx'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormGroup, Input, Label, ModalBody } from 'reactstrap'
import { Link } from 'react-router-dom'
import Icon from '@/components/Icon'

function AuditInfoDialog (props) {
  const { item, closeDialog } = props

  return (
    <div>
      <BasicHeader title='Common.AuditLog' {...props} />
      <ModalBody>
        <FormGroup row>
          <Label><Resx name='Common.ServiceName' /></Label>
          <Input className='form-control' value={item.serviceName} disabled />
        </FormGroup>
        <FormGroup row>
          <Label><Resx name='Common.MethodName' /></Label>
          <Input className='form-control' value={item.methodName} disabled />
        </FormGroup>
        <FormGroup row>
          <Label>
            <Resx name='Common.User' /> <em>(<Resx name='Common.Id' />: {item.userId})</em>
            {item.userId && (
              <Link className='btn-icon ms-2' to={`/users/${item.userId}`} onClick={closeDialog} style={{ verticalAlign: 'middle' }}>
                <Icon name='show' />
              </Link>
            )}
          </Label>
          <Input value={item.userEmail} disabled />
        </FormGroup>
        {item.individualId && (
          <FormGroup row>
            <Label>
              <Resx name='Individuals.Individual' /> <em>(<Resx name='Common.Id' />: {item.individualId})</em>
              <Link className='btn-icon ms-2' to={`/individuals/${item.individualId}`} onClick={closeDialog} style={{ verticalAlign: 'middle' }}>
                <Icon name='show' />
              </Link>
            </Label>
          </FormGroup>
        )}
        {item.bankId && (
          <FormGroup row>
            <Label>
              <Resx name='Institutions.BanksTitle' /> <em>(<Resx name='Common.Id' />: {item.bankId})</em>
              <Link className='btn-icon ms-2' to={`/banks/${item.bankId}`} onClick={closeDialog} style={{ verticalAlign: 'middle' }}>
                <Icon name='show' />
              </Link>
            </Label>
          </FormGroup>
        )}
        {item.companyId && (
          <FormGroup row>
            <Label>
              <Resx name='Institutions.CompaniesTitle' /> <em>(<Resx name='Common.Id' />: {item.companyId})</em>
              <Link className='btn-icon ms-2' to={`/companies/${item.companyId}`} onClick={closeDialog} style={{ verticalAlign: 'middle' }}>
                <Icon name='show' />
              </Link>
            </Label>
          </FormGroup>
        )}
        {item.isCbiEmployee && (
          <FormGroup row>
            <Label><Resx name='Institutions.Institution' />: <Resx name='Individuals.Employee' /></Label>
          </FormGroup>
        )}
        <FormGroup row>
          <Label><Resx name='Common.ExecutionDuration' /></Label>
          <Input value={item.executionDuration} disabled />
        </FormGroup>
        <FormGroup row>
          <Label><Resx name='Common.Parameters' /></Label>
          <Input type='textarea' rows={'5'} value={item.parameters || ''} disabled />
        </FormGroup>
        <FormGroup row>
          <Label><Resx name='Common.ReturnValue' /></Label>
          <Input type='textarea' rows={'1'} value={item.returnValue || ''} disabled />
        </FormGroup>
        <FormGroup row>
          <Label><Resx name='Common.Exception' /></Label>
          <Input type='textarea' rows={'2'} value={JSON.stringify(item.exception)} disabled />
        </FormGroup>
        {/* <FormGroup row>
          <Label><Resx name='Common.BrowserInfo' /></Label>
          <Input value={item.browserInfo} disabled />
        </FormGroup>
        <FormGroup row>
          <Label><Resx name='Common.ClientIpAddress' /></Label>
          <Input value={item.clientIpAddress} disabled />
        </FormGroup> */}
      </ModalBody>
    </div>
  )
}

export default {
  component: AuditInfoDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/auditInfo.js